"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MstrActivity = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
let MstrActivity = class MstrActivity {
    constructor(name, description, leadDays, activityMeta, opportunityTable, activityKey, createdBy, updatedBy) {
        this.name = name;
        this.description = description;
        this.leadDays = leadDays;
        this.activityMeta = activityMeta;
        this.opportunityTable = opportunityTable;
        this.activityKey = activityKey;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
    }
};
exports.MstrActivity = MstrActivity;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], MstrActivity.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: "varchar", length: 255 }),
    tslib_1.__metadata("design:type", String)
], MstrActivity.prototype, "name", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], MstrActivity.prototype, "description", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], MstrActivity.prototype, "description", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "activity_key",
        type: "varchar",
        length: 100,
        nullable: true,
    }),
    tslib_1.__metadata("design:type", String)
], MstrActivity.prototype, "activityKey", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "lead_days", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], MstrActivity.prototype, "leadDays", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "activity_detail_meta", type: "jsonb", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Record !== "undefined" && Record) === "function" ? _b : Object)
], MstrActivity.prototype, "activityMeta", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_table", type: "varchar", nullable: true }),
    tslib_1.__metadata("design:type", String)
], MstrActivity.prototype, "opportunityTable", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], MstrActivity.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], MstrActivity.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], MstrActivity.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at" }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], MstrActivity.prototype, "updatedAt", void 0);
exports.MstrActivity = MstrActivity = tslib_1.__decorate([
    (0, typeorm_1.Entity)("mstr_activity"),
    tslib_1.__metadata("design:paramtypes", [String, String, Number, typeof (_a = typeof Record !== "undefined" && Record) === "function" ? _a : Object, String, String, Number, Number])
], MstrActivity);
